let BaseUrl = "";

const Config = {
	setBaseUrl: (url:string) => {
		BaseUrl = url;
	},
	getBaseUrl: () => {
		return BaseUrl;
	},
};

export default Config;
